<template>
    <div>
        <h1>课程记录</h1>
    </div>
</template>


<script>
export default {
    name: 'CoursePage',
    data() {
        return {
            courseRecords: [],
            totalRecords: 0,
            loading: false
        }
    },
    mounted() {
        this.getCourseRecords();
    },
    methods: {
        getCourseRecords() {
           
            this.$http.get('/course')
                .then(response => {
                    console.log('课程记录',response.data.data);
                
                })
                .catch(error => {
                    console.error('获取课程记录失败:', error);
                    this.$message.error('获取课程记录失败');
                    this.loading = false;
                });
        }
    }
}
</script>
<style scoped>
h1 {
    color: #333;
}
</style>